import React, { useEffect, useState, Component } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ChevronDown, Phone, Calendar, MessageCircle, MapPin, Mail, Clock, ArrowRight, Facebook, Instagram, Linkedin } from 'lucide-react';
import { Button } from './ui/Button';
import { twMerge } from 'tailwind-merge';
const SERVICES = ['General Medical Consultations', 'Minor Surgical Procedures', 'Safe Medical Circumcision', 'Paternity Testing (DNA)', 'Immunizations', 'Pre-Employment Medical Examinations', 'Family Planning', 'Counseling Services', 'Chronic Disease Management', 'Physiotherapy', 'Optician Services', 'Antenatal Care', 'Postnatal Care', 'Laboratory Services', 'ECG Services', 'Ultrasound Services', 'Dentistry'];
function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    setMobileMenuOpen(false);
    setServicesOpen(false);
  }, [location.pathname]);
  const navLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'About Us',
    path: '/about'
  }, {
    name: 'Patient Information',
    path: '/patient-information'
  }, {
    name: 'Doctors & Staff',
    path: '/doctors'
  }, {
    name: 'Facilities',
    path: '/facilities'
  }, {
    name: 'Blog',
    path: '/blog'
  }, {
    name: 'FAQ',
    path: '/faq'
  }, {
    name: 'Contact',
    path: '/contact'
  }];
  return <header className={twMerge('fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white', isScrolled ? 'shadow-soft' : '')} data-id="element-244" data-mp="2kbii2q89ovue">
      {/* Top utility bar — desktop only */}
      <div className="hidden md:block bg-brand-gold text-white" data-id="element-245" data-mp="1ul90lgbsiqiz">
        <div className="max-w-brand mx-auto px-4 sm:px-6 lg:px-8" data-id="element-246" data-mp="1un3e49kqfgd1">
          <div className="flex items-center justify-between h-10 text-sm" data-id="element-247" data-mp="29gyhj024cdgu">
            <div className="flex items-center gap-6" data-id="element-248" data-mp="24in46fcm7ktv">
              <span className="flex items-center gap-2" data-id="element-249" data-mp="24h3ooqys9dt5">
                <Clock className="w-4 h-4 text-white/80" data-id="element-250" data-mp="1gung5n6ou8iz" />
                Monday – Friday: 8:00 AM – 6:00 PM
              </span>
              <a href="mailto:bookings@maishahealth.co.bw" className="flex items-center gap-2 hover:text-white/80 transition-colors" data-id="element-251" data-mp="1bwc5xbchdw08">
                <Mail className="w-4 h-4 text-white/80" data-id="element-252" data-mp="1lrx6d51wio7v" />
                bookings@maishahealth.co.bw
              </a>
              <span className="flex items-center gap-2" data-id="element-253" data-mp="y19q9whu0sa8">
                <MapPin className="w-4 h-4 text-white/80" data-id="element-254" data-mp="t4t4va20os0u" />
                Plot 5245, Tsabong, Botswana
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-255" data-mp="34pa5fs9ypow6">
              {[{
              label: 'WhatsApp',
              href: 'https://wa.me/26773241613',
              Icon: MessageCircle
            }, {
              label: 'Facebook',
              href: '#',
              Icon: Facebook
            }, {
              label: 'Instagram',
              href: '#',
              Icon: Instagram
            }, {
              label: 'LinkedIn',
              href: '#',
              Icon: Linkedin
            }].map(({
              label,
              href,
              Icon
            }) => <a key={label} href={href} target="_blank" rel="noopener noreferrer" aria-label={label} className="w-7 h-7 rounded-full border border-white/50 flex items-center justify-center hover:bg-white hover:text-brand-gold transition-colors" data-id="element-256" data-mp="3ikupir1fgd56">
                  <Icon className="w-3.5 h-3.5" data-id="element-257" data-mp="2ij94arb78ku0" />
                </a>)}
            </div>
          </div>
        </div>
      </div>

      {/* Main navigation row */}
      <div className={twMerge('max-w-brand mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-300', isScrolled ? 'py-2' : 'py-4')} data-id="element-258" data-mp="28mmk84qp5xt1">
        <div className="flex items-center justify-between" data-id="element-259" data-mp="31as6ivxefuuz">
          {/* Logo */}
          <Link to="/" className="flex items-center group shrink-0" data-id="element-260" data-mp="2wbfi46qvqfqa">
            <img src="https://cdn.magicpatterns.com/uploads/cndFLouYwME2MiiED8zkcC/logo.jpg" alt="Maisha Medical Center — your health is our devotion" className="h-12 md:h-14 w-auto object-contain" data-id="element-261" data-mp="2w9maop8fzrh8" />
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-1" data-id="element-262" data-mp="1gtdq6t6pdmtr">
            <Link to="/" className="px-3 py-2 text-sm font-medium text-slate-600 hover:text-brand-red transition-colors" data-id="element-263" data-mp="3sj20y29nvj64">
              Home
            </Link>
            <Link to="/about" className="px-3 py-2 text-sm font-medium text-slate-600 hover:text-brand-red transition-colors" data-id="element-264" data-mp="5c9q9hf8rlp0">
              About Us
            </Link>

            {/* Services Dropdown */}
            <div className="relative group" data-id="element-265" data-mp="f5gsiteoqlkv">
              <button className="flex items-center gap-1 px-3 py-2 text-sm font-medium text-slate-600 hover:text-brand-red transition-colors" onMouseEnter={() => setServicesOpen(true)} onMouseLeave={() => setServicesOpen(false)} data-id="element-266" data-mp="k1fl6t71qpr3">
                Services <ChevronDown className="w-4 h-4" data-id="element-267" data-mp="2pw8n4fozx00d" />
              </button>

              {servicesOpen && <div className="absolute top-full left-1/2 -translate-x-1/2 w-[600px] bg-white shadow-soft-lg rounded-2xl p-6 grid grid-cols-2 gap-x-8 gap-y-3 border border-slate-100" onMouseEnter={() => setServicesOpen(true)} onMouseLeave={() => setServicesOpen(false)} data-id="element-268" data-mp="2uv1o58n3iyjn">
                  {SERVICES.map(service => <Link key={service} to={`/services/${service.toLowerCase().replace(/\s+/g, '-')}`} className="text-sm text-slate-600 hover:text-brand-red hover:translate-x-1 transition-all flex items-center gap-2" data-id="element-269" data-mp="60bw6taq000z">
                      <div className="w-1.5 h-1.5 rounded-full bg-brand-gold/50" data-id="element-270" data-mp="tpo6jwhsae4v" />
                      {service}
                    </Link>)}
                </div>}
            </div>

            <Link to="/patient-information" className="px-3 py-2 text-sm font-medium text-slate-600 hover:text-brand-red transition-colors" data-id="element-271" data-mp="13pf0nx2fmr4f">
              Patient Info
            </Link>
            <Link to="/doctors" className="px-3 py-2 text-sm font-medium text-slate-600 hover:text-brand-red transition-colors" data-id="element-272" data-mp="1naxcvp45cr9x">
              Doctors
            </Link>
            <Link to="/facilities" className="px-3 py-2 text-sm font-medium text-slate-600 hover:text-brand-red transition-colors" data-id="element-273" data-mp="1dchjtglk77xs">
              Facilities
            </Link>
            <Link to="/blog" className="px-3 py-2 text-sm font-medium text-slate-600 hover:text-brand-red transition-colors" data-id="element-274" data-mp="14cbb080t2w4y">
              Blog
            </Link>
            <Link to="/faq" className="px-3 py-2 text-sm font-medium text-slate-600 hover:text-brand-red transition-colors" data-id="element-275" data-mp="ulgqb837k4lm">
              FAQ
            </Link>
            <Link to="/contact" className="px-3 py-2 text-sm font-medium text-slate-600 hover:text-brand-red transition-colors" data-id="element-276" data-mp="kn0vov4z2d7d">
              Contact
            </Link>
          </nav>

          {/* CTA & Mobile Toggle */}
          <div className="flex items-center gap-4" data-id="element-277" data-mp="r5f4416kmz95">
            <div className="hidden md:block" data-id="element-278" data-mp="r3u9yco65ibt">
              <Button href="/book" variant="primary" size="sm" icon={<Calendar className="w-4 h-4" data-id="element-280" data-mp="i58x8y5doxiy" />} data-id="element-279" data-mp="m6c7n54nq1cs">
                Book Appointment
              </Button>
            </div>
            <button className="lg:hidden p-2 text-brand-navy hover:bg-slate-50 rounded-lg" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-281" data-mp="dcfsia9wtp6v">
              {mobileMenuOpen ? <X className="w-6 h-6" data-id="element-282" data-mp="3dq9ge6a1yp1" /> : <Menu className="w-6 h-6" data-id="element-283" data-mp="3ul2s6xmt6k72" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && <div className="lg:hidden absolute top-full left-0 right-0 bg-white shadow-soft-lg border-t border-slate-100 max-h-[80vh] overflow-y-auto" data-id="element-284" data-mp="2631agf5jp9qa">
          <div className="px-4 py-6 flex flex-col gap-4" data-id="element-285" data-mp="2a2a3fhsrh3ks">
            {navLinks.map(link => <Link key={link.name} to={link.path} className="text-lg font-medium text-brand-navy py-2 border-b border-slate-50" data-id="element-286" data-mp="2f3zdov85td7t">
                {link.name}
              </Link>)}
            <div className="py-2 border-b border-slate-50" data-id="element-287" data-mp="1rcu0kntlsz17">
              <div className="text-lg font-medium text-brand-navy mb-3" data-id="element-288" data-mp="1rb94uuvjza1r">
                Services
              </div>
              <div className="flex flex-col gap-3 pl-4" data-id="element-289" data-mp="21354wbh79a8m">
                {SERVICES.slice(0, 8).map(service => <Link key={service} to={`/services/${service.toLowerCase().replace(/\s+/g, '-')}`} className="text-sm text-slate-600" data-id="element-290" data-mp="13osx3tba88sn">
                    {service}
                  </Link>)}
                <Link to="/services" className="text-sm font-medium text-brand-red flex items-center gap-1 mt-2" data-id="element-291" data-mp="ns7bbjavgtkd">
                  View All Services <ArrowRight className="w-4 h-4" data-id="element-292" data-mp="xqwfyadrchio" />
                </Link>
              </div>
            </div>
            <Button href="/book" variant="primary" fullWidth className="mt-4" data-id="element-293" data-mp="3e8d2vu1lg9">
              Book Appointment
            </Button>
          </div>
        </div>}
    </header>;
}
function Footer() {
  return <footer className="bg-brand-navy text-white pt-20 pb-10" data-id="element-294" data-mp="a125fzgwv51l">
      <div className="max-w-brand mx-auto px-4 sm:px-6 lg:px-8" data-id="element-295" data-mp="9zhf6m1mq89j">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-296" data-mp="etli8u7rxw5c">
          {/* Brand */}
          <div data-id="element-297" data-mp="3dhsj90iqimdu">
            <Link to="/" className="inline-flex mb-6" data-id="element-298" data-mp="3dg7wvy6kq9r2">
              <span className="bg-white rounded-2xl p-3 inline-flex" data-id="element-299" data-mp="3ifubaay51w1g">
                <img src="https://cdn.magicpatterns.com/uploads/cndFLouYwME2MiiED8zkcC/logo.jpg" alt="Maisha Medical Center — your health is our devotion" className="h-16 w-auto object-contain" data-id="element-300" data-mp="1zmj0lxhwkki3" />
              </span>
            </Link>
            <p className="text-slate-300 text-sm leading-relaxed mb-6" data-id="element-301" data-mp="1lmrk9q3wys0x">
              Providing comprehensive healthcare services, diagnostics,
              physiotherapy, maternal care, and specialist consultations across
              Botswana.
            </p>
            <div className="flex items-center gap-4" data-id="element-302" data-mp="1bulos6egdsgz">
              {[{
              label: 'Facebook',
              href: '#',
              Icon: Facebook
            }, {
              label: 'Instagram',
              href: '#',
              Icon: Instagram
            }, {
              label: 'LinkedIn',
              href: '#',
              Icon: Linkedin
            }].map(({
              label,
              href,
              Icon
            }) => <a key={label} href={href} target="_blank" rel="noopener noreferrer" aria-label={label} className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-brand-red transition-colors" data-id="element-303" data-mp="o9beivkz14kd">
                  <Icon className="w-5 h-5 text-white" data-id="element-304" data-mp="122j64n91y022" />
                </a>)}
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-305" data-mp="t8xql1p2cerl">
            <h3 className="font-heading font-semibold text-lg mb-6 text-white" data-id="element-306" data-mp="t7cxzhmb75wd">
              Quick Links
            </h3>
            <ul className="space-y-3" data-id="element-307" data-mp="x7wpo5o45hb4">
              {['About Us', 'Patient Information', 'Doctors & Staff', 'Facilities', 'Blog', 'Contact'].map(item => <li key={item} data-id="element-308" data-mp="3af4t26xdre87">
                  <Link to={`/${item.toLowerCase().replace(/\s+/g, '-').replace('&-', '')}`} className="text-slate-300 hover:text-brand-gold transition-colors text-sm flex items-center gap-2" data-id="element-309" data-mp="3aecviqk836fa">
                    <ChevronDown className="w-3 h-3 -rotate-90 text-brand-gold" data-id="element-310" data-mp="3f87dnpk6jdc9" />
                    {item}
                  </Link>
                </li>)}
              <li data-id="element-311" data-mp="2miqnyzny2ajq">
                <Link to="/privacy" className="text-slate-300 hover:text-brand-gold transition-colors text-sm flex items-center gap-2" data-id="element-312" data-mp="2mja88n12hb0x">
                  <ChevronDown className="w-3 h-3 -rotate-90 text-brand-gold" data-id="element-313" data-mp="2wg55z3pin7e5" />
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-314" data-mp="gnpfe30gtr7p">
                <Link to="/terms" className="text-slate-300 hover:text-brand-gold transition-colors text-sm flex items-center gap-2" data-id="element-315" data-mp="grd4mpyvnrgm">
                  <ChevronDown className="w-3 h-3 -rotate-90 text-brand-gold" data-id="element-316" data-mp="2hgsxmgzlqh31" />
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-317" data-mp="2vehgxke0tg5z">
            <h3 className="font-heading font-semibold text-lg mb-6 text-white" data-id="element-318" data-mp="2vf0oc761om5r">
              Contact Us
            </h3>
            <ul className="space-y-4" data-id="element-319" data-mp="30cj168n6nlj1">
              <li className="flex items-start gap-3 text-sm text-slate-300" data-id="element-320" data-mp="30bhjhlbnw0sc">
                <MapPin className="w-5 h-5 text-white shrink-0 mt-0.5" data-id="element-321" data-mp="35b4084qp7z5w" />
                <span data-id="element-322" data-mp="3a4gbld6da9gp">Plot 5245, Tsabong, Botswana</span>
              </li>
              <li className="flex flex-col gap-1 text-sm text-slate-300" data-id="element-323" data-mp="3e4qs3jrsci9t">
                <span className="flex items-center gap-3" data-id="element-324" data-mp="3e6thc1l467dh">
                  <Phone className="w-5 h-5 text-white shrink-0" data-id="element-325" data-mp="3j5efzwkpwizt" />
                  <a href="tel:+2676540244" className="hover:text-brand-gold transition-colors" data-id="element-326" data-mp="3o2n0w4x9314r">
                    +267 6540244
                  </a>
                </span>
                <span className="flex items-center gap-3" data-id="element-327" data-mp="3t78rt0aim2q5">
                  <MessageCircle className="w-5 h-5 text-white shrink-0" data-id="element-328" data-mp="3o8nm4lchuqub" />
                  <a href="https://wa.me/26773241613" target="_blank" rel="noopener noreferrer" className="hover:text-brand-gold transition-colors" data-id="element-329" data-mp="3oaqnu2n0e8ev">
                    +267 73241613 (WhatsApp)
                  </a>
                </span>
              </li>
              <li className="flex items-center gap-3 text-sm text-slate-300" data-id="element-330" data-mp="b1c8jtj9fyxk">
                <Mail className="w-5 h-5 text-white shrink-0" data-id="element-331" data-mp="71bptwp4p1kp" />
                <a href="mailto:bookings@maishahealth.co.bw" className="hover:text-brand-gold transition-colors" data-id="element-332" data-mp="6yzbrumhrbcx">
                  bookings@maishahealth.co.bw
                </a>
              </li>
              <li className="flex items-start gap-3 text-sm text-slate-300" data-id="element-333" data-mp="2t0v6sj8eurgc">
                <Clock className="w-5 h-5 text-white shrink-0 mt-0.5" data-id="element-334" data-mp="2xzg5ge80l32o" />
                <span data-id="element-335" data-mp="2y0rdwrcemz04">
                  Mon - Fri: 8:00 AM - 6:00 PM
                  <br data-id="element-336" data-mp="2j9qrfietp4kz" />
                  Sat: 9:00 AM - 1:00 PM
                  <br data-id="element-337" data-mp="2o8bs1ixzlq9y" />
                  Sun: Closed
                </span>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div data-id="element-338" data-mp="2abownklon865">
            <h3 className="font-heading font-semibold text-lg mb-6 text-white" data-id="element-339" data-mp="2f85j8ad8heh4">
              Newsletter
            </h3>
            <p className="text-slate-300 text-sm mb-4" data-id="element-340" data-mp="20by0lehh4l3y">
              Subscribe to receive health tips and clinic updates.
            </p>
            <form className="flex flex-col gap-3" onSubmit={e => e.preventDefault()} data-id="element-341" data-mp="25ahovljji8zh">
              <input type="email" placeholder="Your email address" className="bg-white/10 border border-white/20 rounded-lg px-4 py-2.5 text-sm text-white placeholder:text-slate-400 focus:outline-none focus:border-brand-gold" data-id="element-342" data-mp="3iw54z1w2lpl" />
              <Button variant="primary" fullWidth data-id="element-343" data-mp="1izzi2x0w3kmq">
                Subscribe
              </Button>
            </form>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-344" data-mp="1syyrwixe5mbb">
          <p className="text-slate-400 text-sm" data-id="element-345" data-mp="26ptrt5pwwt2r">
            © {new Date().getFullYear()} Maisha Medical Center Botswana. All
            rights reserved.
          </p>
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-slate-400" data-id="element-346" data-mp="2gpuf12qwjtc8">
            <span className="font-semibold text-slate-300" data-id="element-347" data-mp="2bpzm6tnkgtoj">Useful Links:</span>
            <a href="https://www.bomra.co.bw/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-348" data-mp="mbjn2lf0gj28">
              BoMRA
            </a>
            <a href="https://www.ilo.org/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-349" data-mp="3rnxcf8ewqg9n">
              ILO
            </a>
            <a href="https://www.who.int/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-350" data-mp="5b752s4gjnbp">
              World Health Organization (WHO)
            </a>
          </div>
        </div>
      </div>
    </footer>;
}
function FloatingActions() {
  const whatsappMessage = encodeURIComponent('Hello Maisha Medical Center.\nI would like to book an appointment.\nName:\nPhone:\nPreferred Service:\nPreferred Date:\nPreferred Time:\n\nPlease assist me.');
  return <>
      {/* Desktop Floating */}
      <div className="hidden md:flex fixed bottom-8 right-8 flex-col gap-4 z-50" data-id="element-351" data-mp="12wuqkhzdkl8g">
        <a href={`https://wa.me/26773241613?text=${whatsappMessage}`} target="_blank" rel="noopener noreferrer" className="w-14 h-14 bg-[#25D366] text-white rounded-full flex items-center justify-center shadow-soft-lg hover:scale-110 transition-transform relative group" data-id="element-352" data-mp="12yz31obcaskc">
          <div className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20" data-id="element-353" data-mp="28qaiokauwk9b" />
          <MessageCircle className="w-7 h-7" data-id="element-354" data-mp="23qxu9v4c754m" />
          <span className="absolute right-full mr-4 bg-white text-slate-800 text-sm font-medium py-1.5 px-3 rounded-lg shadow-soft opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none" data-id="element-355" data-mp="23rphoins5wjt">
            Chat on WhatsApp
          </span>
        </a>
      </div>

      {/* Mobile Sticky Bottom Bar */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-slate-100 shadow-[0_-4px_20px_rgba(0,0,0,0.05)] z-50 px-4 py-3 flex items-center justify-between gap-3 pb-safe" data-id="element-356" data-mp="1pthq6q9ijng1">
        <a href={`https://wa.me/26773241613?text=${whatsappMessage}`} className="flex-1 flex flex-col items-center justify-center gap-1 text-[#25D366]" data-id="element-357" data-mp="3k3d0tjslthvl">
          <MessageCircle className="w-5 h-5" data-id="element-358" data-mp="avjn8lg2xa63" />
          <span className="text-[10px] font-medium" data-id="element-359" data-mp="63jhgcdbvn1l">WhatsApp</span>
        </a>
        <Link to="/book" className="flex-[2] bg-brand-red text-white py-2.5 rounded-xl flex items-center justify-center gap-2 font-medium text-sm shadow-md" data-id="element-360" data-mp="14yishdq5bf9">
          <Calendar className="w-4 h-4" data-id="element-361" data-mp="3t6ejj5isqbd2" />
          Book Now
        </Link>
        <a href="tel:+2676540244" className="flex-1 flex flex-col items-center justify-center gap-1 text-brand-navy" data-id="element-362" data-mp="3o83c11fz4cy0">
          <Phone className="w-5 h-5" data-id="element-363" data-mp="3ebqh608ozt1o" />
          <span className="text-[10px] font-medium" data-id="element-364" data-mp="3ecs2cxjf9vx4">Call Us</span>
        </a>
      </div>
    </>;
}
export function Layout({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="min-h-screen flex flex-col font-sans" data-id="element-365" data-mp="1cjvh6hvstcza">
      <Header data-id="element-366" data-mp="1l1494q7qenm4" />
      <main className="flex-1 pt-[72px] md:pt-[128px] pb-16 md:pb-0" data-id="element-367" data-mp="1l1dxyah1ioq8">
        {children}
      </main>
      <Footer data-id="element-368" data-mp="1p27olblvahmt" />
      <FloatingActions data-id="element-369" data-mp="1p1xwnih9i0eh" />
    </div>;
}